import React, {Component} from 'react';
import FormAliquots from './components/FormAliquots';
import { translate } from 'react-i18next';
import RaisedButton from 'material-ui/RaisedButton';
import Notifications, {notify} from 'react-notify-toast';
import swal from 'sweetalert';
import WaitingModal from '../../generics/WaitingModal';
import moment from 'moment';
import ModalReserved from './components/modalReserved';

var Config = require('../../../config');

class Aliquots extends Component{
	constructor(props){
		super(props);

		this.onSave = this.onSave.bind(this);
		this.clearData = this.clearData.bind(this);
		this.waiting_modal = this.waiting_modal;
		this.onReturn = this.onReturn.bind(this);
		this.saving = this.saving.bind(this);
		this.getReserved = this.getReserved.bind(this);

		this.state = {btnNew:false}
	}

	onSave(){
		var alicuots_process = {};
		if (this.isValidDate(this.form.state.date)){
			if(this.isValidForm()){
				alicuots_process = this.form.getDataForm();

				this.saveData(alicuots_process)
			}else{
				swal('¡Error!', "Campos incompletos", 'error');
			}
		} else {
	    	notify.show('Error, Fecha no válida','error');
	    }
	}

	isValidDate(fecha){
		var valid = moment(fecha).format('MM-DD-YYYY');

		if(valid === 'Invalid date'){
			return false;
		}else{
			return true;
		}
	}

	saveData(data, aux){
		if(data.alicuots_process !== undefined){
			
			if(data.alicuots_process.alicuots_parts === "error"){
				notify.show('Error, Tabla incompleta', 'error');

			}else if(data.alicuots_process.hour === "Invalid date"){
				notify.show('Error, Hora invalida', 'error');
				
			}else if(data.alicuots_process.alicuots_parts === "bloqueo"){
				//notify.show('Error, Tabla incompleta', 'error');

			}else{
				if(this.form.state.reserved_list.length > 0){
					this.modal_reserved.handleShow(this.form.state.reserved_list);
				}else{
					this.saving(data);
				}

			}
		}
	}

	getReserved(result){
		var alicuots_process = this.form.getDataForm();
		alicuots_process.reserved_units = result;

		this.saving(alicuots_process);
	}

	saving(data){
		if(this.waiting_modal === undefined){
			this.waiting.handleShow('Guardando...');
		}else{
			this.waiting_modal.handleShow('Guardando...');	
		}
		
		fetch(Config.default.apiGateway.URL+'alicuots_process',{
			method : 'post',
			body: JSON.stringify(data),
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(this.waiting_modal === undefined){
				this.waiting.handleClose();
			}else{
				this.waiting_modal.handleClose();
			}
			
            if(res.ok){
              return res.json();
            }else{
	            res.text().then(function(result) {
	                swal('¡Error!', result, 'error');
	            });
            }
        }).then(function(response){
			if(response !== undefined){
				swal('¡Buen Trabajo!', "Proceso Terminado", 'success');
				

				if(this.form !== undefined){
					if(this.form.state.option !== 'Unit'){
						this.clearData();
					}					
				}else{
					this.clear();
				}

				if(this.form.state.option !== 'Unit'){
					this.props.history.push('/aliquots');

					
				}else{
					this.form.setState({
						alicuot_ids:response.unit_ids
					});
					this.setState({btnNew:true});
				}
				
			}
		}.bind(this));
	}

	clearData(){
		this.form.setState({
			equipment_id:"",
			aliquots:[],
			alicuot_ids:[],
			pending:false
		});

		this.form.table.setState({
			component:[],
			all:false,
			num_alicuots:""
		});
		this.setState({btnNew:false});
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.form.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	onReturn(){
		this.props.history.push('/aliquots');
	}


	render(){
		const {t} = this.props;
		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.process.MAIN')} ->
						{t('sidebar.nav.process.aliquots.MAIN')}
					</h5>
				</div>
				
				<form noValidate>
					<FormAliquots saving={this.saveData} clear={this.clearData} printLabel={this.printLabel} {...this.props} onRef={ref => (this.form = ref)} />
					<Notifications />
				</form>

				<div className="col-xs-12" style={{textAlign:'center'}}>
		        	<div>
		        		{!this.state.btnNew ?
		        			<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} onClick={this.onSave}  style={{margin:12}}/>
		        		: <RaisedButton className="action-btn" label={'Nuevo'} primary={true} onClick={this.clearData}  style={{margin:12}}/>}
		        		
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} style={{margin:12}} onClick={this.onReturn}/>
		        	</div>
		        </div>
		        <ModalReserved {...this.props} onRef={ref => (this.modal_reserved = ref)} getReserved={this.getReserved} />
		        <WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
			</div>
		)
	}
}

export default translate('translations')(Aliquots);